import { processSteps } from "@/config/content";
import { Reveal } from "@/lib/motion";

export const Process = () => (
  <section id="ablauf" className="py-20 lg:py-28 bg-forest text-white scroll-mt-20 relative overflow-hidden" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">Ablauf</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">So läuft Ihre Anfrage ab</h2>
        <p className="mt-5 text-lg text-white/70 leading-relaxed">
          In vier klaren Schritten vom ersten Kontakt zum abgestimmten Angebot. Falls nötig, wird
          eine Besichtigung individuell vereinbart.
        </p>
      </Reveal>

      <ol className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {processSteps.map((s, i) => (
          <Reveal as="li" key={s.n} delay={i * 0.08}>
            <div data-testid={`process-step-${s.n}`} className="h-full rounded-2xl border border-white/12 bg-white/[0.04] p-7">
              <span className="font-heading font-extrabold text-5xl text-gold/90 leading-none">{s.n}</span>
              <h3 className="mt-5 font-heading font-bold text-xl">{s.title}</h3>
              <p className="mt-2.5 text-white/70 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
